import { render, staticRenderFns } from "./remondClass.vue?vue&type=template&id=2ea1b80c&scoped=true&"
import script from "./remondClass.vue?vue&type=script&lang=js&"
export * from "./remondClass.vue?vue&type=script&lang=js&"
import style0 from "./remondClass.vue?vue&type=style&index=0&id=2ea1b80c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea1b80c",
  null
  
)

export default component.exports